<div class="backgroundColor h-screen overflow-y-auto">
  <!-- <div class="row h-full max-h-full"> -->
  <div class="h-full">
    <div class="flex justify-center w-full h-full">
      <div class="flex flex-col lg:w-11/12 xl:w-10/12 h-full overflow-x-hidden">
        <mat-card
          *ngIf="!loading"
          [ngStyle]="{
            'background-color': getColorScheme(),
            color: getTextColor()
          }"
          class="rounded-none xl:rounded-md"
        >
          <mat-icon
            style="scale: 2"
            class="close-icon float-right cursor-pointer"
            (click)="cancelTransaction()"
            *ngIf="!buttonLoading"
            >close</mat-icon
          >
          <mat-card-header class="grid grid-cols-1">
            <div
              class="w-full flex justify-center"
              mat-card-avatar
              *ngIf="session.sessionDisplayInformation.merchantLogo"
            >
              <img
                class="merchant-logo"
                [src]="session.sessionDisplayInformation.merchantLogo"
                alt="company logo"
              />
            </div>
            <mat-card-title class="text-center">{{
              session.sessionDisplayInformation.label
            }}</mat-card-title>
          </mat-card-header>
          <mat-card-content class="border-t-2 border-gray-300">
            <div class="grid grid-cols-12 items-end">
              <div class="col-span-6">
                <div
                  class="w-full subtitle truncate"
                  [matTooltip]="
                    session.sessionDisplayInformation.merchantReference
                  "
                  [ngStyle]="{
                    color: getTextColor()
                  }"
                >
                  <span class="hidden md:inline">Ref: </span>
                  <b>{{
                    session.sessionDisplayInformation.merchantReference
                      | slice : 0 : 40
                  }}</b>
                </div>
                <!-- <p class="subtitle">View order details <mat-icon>view_list</mat-icon></p> -->
              </div>
              <div class="col-span-6 text-right">
                <div class="w-full subtitle">
                  <span class="hidden md:inline">Amount Due</span>
                  <div
                    class="mcp-menu-trigger inline-block ml-1 cursor-pointer bg-transparent border-none p-0 font-bold text-inherit"
                    [matMenuTriggerFor]="currencyMenu"
                    *ngIf="!buttonLoading && !lockMCPList && charge != null"
                  >
                    <b class="amount lg:text-2xl"
                      >{{ charge.currency }}
                      {{ charge.amount | number : "1.2-3" }}</b
                    >
                    <mat-icon class="inline-block ml-1 text-inherit"
                      >arrow_drop_down</mat-icon
                    >
                  </div>
                  <mat-menu
                    #currencyMenu="matMenu"
                    class="mcp-menu mat-primary"
                    overlayPanelClass="mcp-dropdown-overlay"
                  >
                    <div
                      mat-menu-item
                      xPosition="before"
                      *ngFor="let x of listOfCurrencyCodes"
                      (click)="selectCurrency(x)"
                      [ngClass]="{
                        'mat-option qinline-flex justify-between gap-x-4 w-full': true,
                        'mat-selected': x.currency === charge.currency
                      }"
                    >
                      <b>{{ x.currency }}</b>
                      <span>{{ x.amount | number : "1.2-3" }}</span>
                    </div>
                  </mat-menu>
                  <b
                    class="amount lg:text-2xl"
                    *ngIf="(buttonLoading || lockMCPList) && charge != null"
                    >{{ charge.currency }}
                    {{ charge.amount | number : "1.2-3" }}</b
                  >
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <div
          #paymentsContainer
          [ngClass]="getClassesForPaymentsContainer()"
          class="flex-grow h-full w-full overflow-y-auto overflow-x-hidden thin-scrollbar py-2 px-0 sm:px-1 lg:px-2"
        >
          <div
            class="grid grid-cols-1 min-h-full"
            [ngClass]="{
              'md:grid-cols-2 gap-x-4 gap-y-8':
                !loading && !paymentComplete && !processingFailed
            }"
          >
            <div>
              <div
                *ngIf="loading"
                class="flex flex-col items-center justify-center h-full text-center"
              >
                <mat-spinner></mat-spinner>
              </div>
              <router-outlet></router-outlet>
            </div>
            <div
              *ngIf="!loading && !paymentComplete && !processingFailed"
              class="h-full"
            >
              <app-payments-version-two></app-payments-version-two>
            </div>
          </div>
        </div>
        <div class="w-full inset-x-0 relative bottom-0 flex-1">
          <div class="grid grid-cols-1 items-center p-2">
            <p class="text-center secure-tag-message hidden md:inline">
              Secured By
            </p>
            <img
              class="text-center"
              class="secure-adumo-logo p-2"
              src="assets/icons/Icons/Group.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
